<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-card>
      <v-card-text class="pa-5">
        <v-row>
          <v-col>
            <landing-form :errors="errors" @onSubmit="submit"/>
          </v-col>
        </v-row>
        <v-snackbar
          v-model="snackbarSuccess"
          :timeout="timeout"
          color="success"
        >
          Сохранено

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              @click="snackbarSuccess = false"
              color="red"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        <v-snackbar
          v-model="snackbarError"
          :timeout="timeout"
          color="error"
        >
          {{ this.errors }}

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              @click="snackbarError = false"
              color="red"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import LandingForm from '../../../components/landings/LandingForm';
import { Landing } from '../../../models/landing';

export default {
  name: 'Create',
  components: { LandingForm },
  data: () => ({
    parent_id: null,
    errors: {},
    snackbarSuccess: false,
    snackbarError: false,
    timeout: 2000,
    page: {
      title: "Создание лендинга"
    },
    breadcrumbs: [
      {
        text: "Админ панель",
        disabled: false,
        to: '/'
      },
      {
        text: "Лендинги",
        disabled: false,
        to: '/landings'
      },
      {
        text: "Создание",
        disabled: true,
        to: '/create'
      }
    ],
  }),
  mounted() {
    if (this.$route.params.parent_id) {
      this.parent_id = this.$route.params.parent_id
    }
  },
  methods: {
    async submit({form, isNeedRedirect}) {
      try {
        this.errors = {};
        const landing = await Landing.$query().store({ ...form, parent_id: this.parent_id });
        this.snackbarSuccess = true;
        if (isNeedRedirect) {
          await this.$router.push({name: 'landings-index'});
        } else {
          await this.$router.push({name: 'landings-edit', params: {id: landing.$attributes.id}});
        }
      } catch (e) {
        this.snackbarError = true;
        if (e.response?.data) {
          this.errors = e.response.data.errors
        }
        throw e;
      }
    },
  },
};
</script>
